package com.tixforgigs.common.ui.components.account

import com.tixforgigs.common.core.annotations.MissingTaramiIconKey
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.routing
import com.tixforgigs.common.core.extensions.navigateTo
import io.kvision.core.AlignItems
import io.kvision.core.Container
import io.kvision.core.Cursor
import io.kvision.event.clickFlow
import io.kvision.html.span
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.icon.icon
import io.kvision.panel.hPanel
import io.kvision.utils.px
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach

@OptIn(ExperimentalMaterialApi::class)
fun Container.genericBackButton(
  text: String,
  navigateTo: View
) {
  hPanel(
    alignItems = AlignItems.CENTER,
    spacing = 4
  ) {
    marginBottom = 16.px
    cursor = Cursor.POINTER
    @MissingTaramiIconKey
    icon("arrow_back")
    span(text)
  }.clickFlow.onEach {
    routing.navigateTo(navigateTo)
  }.launchIn(MainScope())
}